import { query_my_zhun_bei_org_list } from 'liyu-pc-base/api/org-model';

export default () => {
  const search_config: any = {
    model: {
      is_active: true,
    },
    watch: [],
  };

  return {
    getData: query_my_zhun_bei_org_list,
    searchConfig: search_config,
  };
};
